import { App } from 'antd';
import Icon from '../../cpn/Icon';
import {  useDingdanzhichuDelMutation } from '../../store/DianShangYeWuApi';   
function CostDel(props) {
    const {modal,message} = App.useApp(); 
    const [submitDel] = useDingdanzhichuDelMutation()  
    return (
        <Icon type='delete'  onClick={() => {            
            modal.confirm({
                title: '点击确定删除付款单',
                content: '删除后不能恢复！',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    submitDel({
                        ddzc_id:props.ddzc_id+'',
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('删除成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('删除失败！'+res.data.Message)
                        }
                    })
                },
                onCancel() {
                    // console.log('Cancel');
                },
            }); 
        }}/>
    )
}

export default CostDel